function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconYenCoinOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.672 16c0-5.286 3.046-9.861 7.48-12.065a13.365 13.365 0 015.984-1.4C23.572 2.536 29.6 8.565 29.6 16s-6.028 13.464-13.464 13.464C8.7 29.464 2.672 23.436 2.672 16zm13.464 11.183c6.176 0 11.183-5.007 11.183-11.183S22.312 4.817 16.136 4.817 4.953 9.824 4.953 16 9.96 27.183 16.136 27.183z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.764 16.212L10.657 10h2.654l2.776 6.71L18.923 10h2.421l-3.098 6.212H20.5v1.616h-3.372v1.923h3.372v1.616h-3.372V24H14.92v-2.652h-3.428V19.75h3.39v-1.924h-3.39v-1.615h2.272z",
    fill: props.color
  }));
}

export default SvgIconYenCoinOutline;